// extracted by mini-css-extract-plugin
module.exports = {"root":"Link_root__oD0h6","cta":"Link_cta__2XNCy","isActive":"Link_isActive__1kPsR","content":"Link_content__B15BZ"};